<template>
    <div class="step1">
		<p class="p">推荐使用<font>下载导入模板</font>，将数据填写在下载的模板中上传，可减少系统表头匹配工作，更快的进行数据导入。</p>
		  <div class="uploadBox">
			  <el-upload
				v-loading="loading"
				:show-file-list="false"
				:on-success="fileUploadSuccess"
				:on-error="fileUploadError"
				:before-upload="beforeFileUpload"
				:action="uploadUrl"
				class="uploadContent"
				drag
				accept=".xls,.xlsx">
				<i class="el-icon-upload"/>
				<div class="el-upload__text">点击或将文件拖到此处上传</div>
			  </el-upload>
		</div>
		<div class="div">
			<div>
				请选择上传sheet页：<el-select style="width: 190px;">
				<el-option label="区域一" value="shanghai"></el-option>
				<el-option label="区域二" value="beijing"></el-option>
			</el-select>
			</div>
			<div>
				<div>
					请输入表头所在行：<el-input  style="width: 64px;"></el-input> 行
				</div>
				<div style="text-align: right;">
					<span class="errorBox">
						<img src="@/assets/img/dataImport/tishi copy.png" />
						<span>您输入的行数未查找到数据</span>
					</span>
				</div>
			</div>

		</div>
		<div class="footer">
			<div>温馨提示：</div>
			<div>
				<p>1.支持文件后缀 xls、xlsx文件，且不超过10M</p>
				<p>2.请不要加密模板文件，将导致错误</p>
			</div>
		</div>
		<div style="margin-top: 8px;padding-bottom: 24px;text-align:center;">
			<el-button type="primary" @click="next()">上传</el-button>
		</div>
    </div>

</template>

<script>
  export default {
    name: "step1",
    props: {
        step: {
            type: String,
            default: '',
        }
    },
    data() {
      return {
          uploadUrl: "",//导入地址
        loading: false,
      };
    },
    methods: {
		 beforeFileUpload(file) {
        this.$set(this, "loading", true);
        let isExcel = true;
        const isxls = file.type === "application/vnd.ms-excel";
        const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const isLtM = file.size / 1024 / 1024 < 10;

        if (!isxls && !isxlsx) {
          isExcel = false;
          this.$message.error("导入文件只能是 xls,xlsx 格式!");
          this.$set(this, "loading", false);
        }
        if (!isLtM) {
          this.$message.error("导入文件大小不能超过 10MB!");
          this.$set(this, "loading", false);
        }
        return isExcel && isLtM;
      },
      fileUploadSuccess(res, file, fileList) {
        this.$set(this, "loading", false);
        if (res) {
          if (res.statusCode !== 200) {

            this.$message.error(res.msg);
          } else {
            // 赋值数据  用于下一个页面使用
            this.$store.state.impData.contentList = res.data.contentList;
            this.$store.state.impData.noMatchTitleList = res.data.noMatchTitleList;
            this.$store.state.impData.matchTitleList = res.data.matchTitleList;
            this.$store.state.impData.fileTitleList = res.data.fileTitleList;
            this.next = true;
          }
        }
      },
      fileUploadError(err, file, fileList) {
        this.$set(this, "loading", false);
        this.$message.error("导入失败!");
      },
	  next(){
		  this.$emit('update:step', 'step2')
	  }
    }
  };
</script>

<style scoped >
	.step1 .p{
		text-align: center;
        padding:20px 0;
		font-size:13px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(51,51,51,1);
		line-height:18px;
	}
   .step1 p font{
	   color: #0EA5E5;
	   padding: 0 4px;
	   cursor: pointer;
   }
   .step1>.div{
	   display: flex;
	   justify-content: space-between;
	   width: 644px;
	   margin: 12px auto 45px;
   }
   .step1>.div div{
	   font-size:13px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(51,51,51,1);
		line-height:18px;
   }
   .uploadBox >>> .el-upload-dragger {
   width: 644px;
   height: 210px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .uploadBox >>> .uploadContent{
	  text-align: center;
  }
  .footer{
  display: flex;
  margin-top: 16px;
  }
  .footer div{
  font-size:13px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:18px;
  }
  .footer p{
  font-size:13px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:18px;
  margin-bottom: 8px;
  text-align: left;
  }
  .errorBox{
	  display: inline-block;
	  height:30px;
		background:rgba(255,251,229,1);
		border-radius:4px;
		border:1px solid rgba(232,221,163,1);
		line-height: 30px;
		padding: 0 4px;
		margin-top: 6px;
  }
  .errorBox span,.errorBox img{
	  vertical-align: middle;
  }
  .errorBox img{
	  margin-right: 10px;
  }
  .errorBox span{
	  font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(255,0,0,1);
		line-height:17px;
  }
</style>
